import React, { PropsWithChildren, useMemo } from 'react'

type UseBody = {
  rowComponent: React.FC<PropsWithChildren>
  data: Array<any>
}
export const useBody = ({ rowComponent, data }: UseBody) => {
  return useMemo(() => {
    const Row = rowComponent

    return data.map((rowData, index) => (
      <Row key={index + index} {...rowData} />
    ))
  }, [data, rowComponent])
}
